import { useEffect, useState } from "react";
import ApiService from "../../Service/ApiService";
import { Card } from "antd";
import Title from "antd/es/typography/Title";
import { useNavigate } from "react-router-dom";
import "./SelectHotelPage.css";

const SelectHotelPage = () => {
  const [hotels, setHotels] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchHotels = async () => {
      const results = await ApiService.fetchHotels();
      setHotels(results);
    };
    fetchHotels();
  }, []);

  const handleHotelSelect = (id) => {
    const hotel = hotels.find((h) => h.id === id);
    if (hotel) {
      navigate(`/rooms`, { state: { id: id, currency: hotel.currency } });
    }
  };
  return (
    <div className="default-container">
      <h2>Select a Hotel to Continue</h2>
      <div className="hotel-selection-container">
        {hotels.map((hotel, idx) => {
          return (
              <Card
                key={idx}
                hoverable
                onClick={() => handleHotelSelect(hotel.id)}
                className="hotel-selection-card"
                cover={
                  <img
                    alt={hotel.name}
                    src={hotel.hotelImage}
                    style={{
                      height: "300px",
                      width: "100%",
                      objectFit: "cover",
                    }}
                  />
                }
              >
                <Title level={4}>{hotel.name}</Title>
                <p> {hotel.description}</p>
                <br />
                <p strong>Address: {hotel.address}</p>
              </Card>
          );
        })}
      </div>
    </div>
  );
};

export default SelectHotelPage;
